import React, { useState } from 'react';
import speakerFemi from '../../../utils/images/speaker_femi.png'
import speakerCon from '../../../utils/images/speaker_prof.png'
import speakerGodwin from '../../../utils/images/godwin.png';
import speakerDickson from '../../../utils/images/SpeakerDickson.png';


import './homepage.css';

// Event plan data
const scheduleData = [
  {
    day: 'DAY 1',
    dayOfWeek: 'Saturday',
    date: 'DEC. 7TH',
    schedule: [
      { time: '9:00AM - 10:00AM', title: 'Registration/ Door opens' },
      { time: '10:00AM - 10:20AM', title: 'Kick off/ About conference' },
      {
        time: '10:20AM - 10:55AM',
        title: 'Designing for Family Influence',
        details: 'Apostle Femi Lazarus is a dynamic Nigerian preacher, teacher, and leader of The Sphere of Light Church in Ibadan. Known for his profound teachings on spiritual growth and personal development, he has impacted many lives through his ministry and outreach programs. Apostle Femi is passionate about raising a generation of believers who are deeply rooted in the Word of God and committed to transforming their communities. He is also a sought-after speaker, mentor, and author.',
        speaker: 'Coming Soon',
      },
      {
        time: '10:55AM - 11:30AM',
        title: 'Designing for Government Influence.',
        details: 'Apostle Femi Lazarus is a dynamic Nigerian preacher, teacher, and leader of Light Nation Church in Ibadan. Known for his profound teachings on spiritual growth and personal development, he has impacted many lives through his ministry and outreach programs. Apostle Femi is passionate about raising a generation of believers who are deeply rooted in the Word of God and committed to transforming their communities. He is also a sought-after speaker, mentor, and author.',
        speaker: 'Coming Soon',
      },
      { time: '11:30AM - 12:05PM', 
        title: 'Designing for Business Influence.',
        details: `Godwin Aigboviose Omage is a visionary innovator and serial entrepreneur, renowned for founding:

        - Co-Net Technologies Ltd. (a climate tech company),
        - Eki Digital Multipurpose Coy. Ltd., (a global trade zone),
        - Sotech (specializing in self-order technology),
        - GAF Africa (a foundation for tech support and research),
        - Love Lead, (an NGO focused on rural human capital development and infrastructure).
      
        His enterprises encompass cutting-edge digital solutions, hospitality management, and environmental sustainability.
        
        Omage's leadership has earned him a top spot on The 100 Voices for Our Planet list, an initiative by JB Dondolo, and recognition in the United Nations Water Action Agenda, featured on the UN Partnership for Goals website. This accolade follows his development of:
        
        - Eki Co-Net, a digital solution replacing paper business cards and promoting eco-friendly practices
        - Love Funds, a global fundraising platform for businesses and individuals
        
        Godwin's impact reflects his commitment as a passionate visionary leader.`,
        speaker: 'Keynote Speaker',
        speakerImg: speakerGodwin,
        speakerName: 'Godwin Aigboviose Omage',
        speakerDes: 'Founder, Co-Net technologies Ltd',
      },
      { time: '12:05PM - 12:35PM', 
        title: 'What is Nation Building.',
        details: `Hon. Chief Dickson Fineboy Ebegbare is a seasoned political technocrat from Delta State, Nigeria. With a distinguished career in public service, he has held various influential positions, including; Supervisory Councilor for Works, Isoko South Local Government Area (LGA). Vice Chairman and Acting Chairman, Isoko South LGA. Special Assistant and later Senior Special Assistant to the Governor of Delta State.

        Hon. Ebegbare recently served as the Social Democratic Party (SDP) House of Representatives candidate in the National Assembly election, showcasing his commitment to democratic ideals and public service. His leadership reflects a dedication to community development and effective governance.`,
        speaker: 'Keynote Speaker',
        speakerImg: speakerDickson,
        speakerName: 'Hon. Fineboy D. Ebegbare',
        speakerDes: 'Political Technocrat',
      },
      { time: '12:35PM - 1:05PM', title: 'Questions & Answers',},
      { time: '1:05PM - 1:15PM', title: 'Partners and Sponsors Advert',},
      { time: '1:15PM - 2:00PM', title: 'Break Out (Meal, Network & Games)',},
      {
        time: '2:00PM - 2:35PM',
        title: 'Designing for Media influence.',
        details: '',
        speaker: 'Coming Soon',
      },
      {
        time: '2:35PM - 3:10PM',
        title: 'Designing for Educational influence.',
        details: 'Prof. Conrad Omonhinmin is a professor and director of Covenant University  Research, Innovation and Discovery (CUCRID). He is a Plant Biotechnology expert and his research spans across Molecular Systematics, Plant Genetic Diversity, and Biodiversity Conservation, with a focus on under-utilized African plant species. He is also involved in renewable energy research and environmental management, particularly through the use of plant species for biofuel production and ecosystem sustainability. His work contributes to innovative biotechnology solutions for agriculture, environmental challenges, and energy development.',
        speaker: 'Keynote Speaker',
        speakerImg: speakerCon,
        speakerName: 'Prof. Conrad Omonhinmin',
        speakerDes: 'Director CUCRID Covenant University',
      },
      { time: '3:10PM - 3:45PM', title: 'Designing for Church Influence',
        details: 'Apostle Femi Lazarus is a dynamic Nigerian preacher, teacher, and leader of Light Nation Church in Ibadan. Known for his profound teachings on spiritual growth and personal development, he has impacted many lives through his ministry and outreach programs. Apostle Femi is passionate about raising a generation of believers who are deeply rooted in the Word of God and committed to transforming their communities. He is also a sought-after speaker, mentor, and author.',
        speaker: 'Keynote Speaker',
        speakerImg: speakerFemi,
        speakerName: 'Apst. Femi Lazarus',
        speakerDes: 'Founder, The Light Nation',
      },
      { time: '3:45PM - 4:10PM', title: 'Questions & Answers',},
      { time: '4:10PM - 4:20PM', title: 'Closing Remarks',},
      { time: '4:30PM', title: 'Closing' },
    ],
  },
  // {
  //   day: 'DAY 2',
  //   dayOfWeek: 'Saturday',
  //   date: 'DEC 7TH',
  //   schedule: [
  //       { time: '9:00AM - 10:00AM', title: 'Registration/ Door opens' },
  //       { time: '10:00AM - 10:15AM', title: 'Kick off/ About conference' },
  //       {
  //         time: '10:15AM - 10:50AM',
  //         title: 'Designing for Media influence',
  //         details: 'Apostle Femi Lazarus is a dynamic Nigerian preacher, teacher, and leader of The Sphere of Light Church in Ibadan. Known for his profound teachings on spiritual growth and personal development, he has impacted many lives through his ministry and outreach programs. Apostle Femi is passionate about raising a generation of believers who are deeply rooted in the Word of God and committed to transforming their communities. He is also a sought-after speaker, mentor, and author.',
  //         speaker: 'Coming Soon',
  //         speakerImg: speakerFemi
  //       },
  //       {
  //         time: '10:50PM - 11:25AM',
  //         title: ' Designing for Business influence.',
  //         details: 'Apostle Femi Lazarus is a dynamic Nigerian preacher, teacher, and leader of The Sphere of Light Church in Ibadan. Known for his profound teachings on spiritual growth and personal development, he has impacted many lives through his ministry and outreach programs. Apostle Femi is passionate about raising a generation of believers who are deeply rooted in the Word of God and committed to transforming their communities. He is also a sought-after speaker, mentor, and author.',
  //         speaker: 'Coming Soon',
  //         speakerImg: speakerFemi
  //       },
  //       { time: '11:25AM - 12:00PM', title: 'Questions & Answers',},
  //       { time: '12:00PM - 12:20PM', title: 'Partners and Sponsors Advert',},
  //       { time: '12:20PM - 1:00PM', title: 'Break Out (Meal, Network & Games)',},
  //       {
  //         time: '1:00PM - 1:35AM',
  //         title: 'What is Nation Building.',
  //         details: 'Apostle Femi Lazarus is a dynamic Nigerian preacher, teacher, and leader of The Sphere of Light Church in Ibadan. Known for his profound teachings on spiritual growth and personal development, he has impacted many lives through his ministry and outreach programs. Apostle Femi is passionate about raising a generation of believers who are deeply rooted in the Word of God and committed to transforming their communities. He is also a sought-after speaker, mentor, and author.',
  //         speaker: 'Coming Soon',
  //         speakerImg: speakerFemi
  //       },
  //       { time: '1:35PM - 2:10PM', title: 'The Global Impact of Design',
  //         details: 'Apostle Femi Lazarus is a dynamic Nigerian preacher, teacher, and leader of The Sphere of Light Church in Ibadan. Known for his profound teachings on spiritual growth and personal development, he has impacted many lives through his ministry and outreach programs. Apostle Femi is passionate about raising a generation of believers who are deeply rooted in the Word of God and committed to transforming their communities. He is also a sought-after speaker, mentor, and author.',
  //         speaker: 'Coming Soon',
  //         speakerImg: speakerFemi
  //       },
  //       { time: '2:10PM - 2:30PM', title: 'Questions & Answers',},
  //       { time: '2:30PM - 3:30PM', title: 'Panel and Interactive session',},
  //       { time: '3:30PM', title: 'Closing' },
  //     ],
  // },
  // More days can be added here...
];

const ScheduleSection = () => {
  const [activeDay, setActiveDay] = useState(0);
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  return (
    <section id='schedule-section' className='schedule-section page-width px-3 my-0 my-md-5 py-0 py-md-5'>
      <h2 className="text-center text-uppercase py-5 mt-5">CONFERENCE SCHEDULES</h2>

      <section className="tabs mb-5">
        {scheduleData.map((dayData, index) => (
          <button key={index} className={activeDay === index ? 'active' : ''}
            onClick={() => setActiveDay(index)}
          >
            {dayData.day} - <span className='d-none d-md-block'>{dayData.dayOfWeek},</span> {dayData.date}
          </button>
        ))}
      </section>

      {/* Schedule breakdown */}
      <section className="schedule-list mb-0 mb-md-5 pb-0 pb-md-5">
        {scheduleData[activeDay].schedule.map((item, index) => (
            <div key={index} className='schedules position-relative overflow-hidden'>
              <div className={`schedule-item row ${item.speaker === 'Coming Soon' ? '' : 'accordion-header'}`}
                  onClick={item.speaker ? item.speaker === 'Coming Soon' ? null : () => toggleAccordion(index) : null}
              >
                <div className="col-md-3 col-sm-12 js-scroll slide-left"><p className='duration'>{item.time}</p></div>
                <div className="col-md-9 col-sm-12 js-scroll slide-right">
                  {item.details ? (
                  <div className='d-flex justify-content-between gap-1'>
                      <p className='event-title'>{item.title}</p>
                      {item.speaker === 'Coming Soon' ? (
                      <div className='d-flex gap-2'>
                          <p className='duration d-none d-md-block'>{item.speaker}</p>
                      </div>
                      ):(
                      <div className='d-flex gap-2'>
                          <p className='duration d-none d-md-block'>{item.speaker}</p>
                          <p className='accordion-btn'>{openAccordion === index ? '-' : '+'}</p>
                      </div>
                      )}
                  </div>
                  ) : (
                    <p className='event-title'>{item.title}</p>
                  
                  )}
                </div>
              </div>

              {openAccordion === index && (
                  <div className="accordion-content">
                      <div className="accordion-detail row gap-3">
                        <div className="col-md-2 col-sm-12"></div>
                        <div className="col-md-4 col-sm-12 mb-3">
                          <div className="profile-details">
                              <img src={item.speakerImg} alt="profile pic" className='' />
                              <div className="profile-info">
                                  <h3 className='custom-thunder'>{item.speakerName}</h3>
                                  <p className='custom-cosmos'>{item.speakerDes}</p>
                              </div>
                          </div>
                        </div>
                        <div className='accordion-text col-md-5 col-sm-12 mb-3'><p>{item.details}</p></div>
                      </div>
                  </div>
              )}
            </div>
        ))}
      </section>
    </section>
  );
};

export default ScheduleSection;
